<template>
    <div>
        <a-modal centered :bodyStyle="{ padding: 0, 'max-width': '100%' }" :visible="visible" :closable="false" :footer="null">
            <!-- header -->
            <div class="custom-modal-header">
                <div style="display: inline-block" @click="cancel()">
                    <span class="fe fe-chevron-left" style="color: #707070; font-size: 18px; margin: auto 0" />
                    <label style="color: #707070 !important; font-size: 14px; font-weight: 600">
                        {{ $t('Back') }}
                    </label>
                </div>
                <label class="custom-modal-header-title">
                    {{ step == 'filter' ? $t('Filter') : step == 'category' ? 'Category / หมวดหมู่' : step == 'member_type' ? 'Member Type / ประเภทบัตรสมาชิก' : step == 'tag' ? 'Tag / ป้ายกำกับ' : step == 'sort' ? 'Sort' : '' }}
                </label>
                <label style="color: #707070 !important; font-size: 14px; font-weight: 600" @click="onModalClearAll()">
                    {{ $t('Clear All') }}
                </label>
            </div>
            <!-- body -->
            <!-- section filter -->
            <template v-if="step == 'filter'">
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalStepChange('category')">
                    <label class="custom-modal-body-detail"> Category / หมวดหมู่ </label>
                    <span class="fe fe-chevron-right" style="color: #707070; font-size: 18px; margin: auto 0" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalStepChange('member_type')">
                    <label class="custom-modal-body-detail"> Member Type / ประเภทบัตรสมาชิก </label>
                    <span class="fe fe-chevron-right" style="color: #707070; font-size: 18px; margin: auto 0" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalStepChange('tag')">
                    <label class="custom-modal-body-detail"> Tag / ป้ายกำกับ </label>
                    <span class="fe fe-chevron-right" style="color: #707070; font-size: 18px; margin: auto 0" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
            </template>
            <!-- section category -->
            <template v-if="step == 'category'">
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('scg_deal')">
                    <label class="custom-modal-body-detail"> SCG Deal / ดีลจากเอสซีจี </label>
                    <span v-if="data && data.scg_deal" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('partner_deal')">
                    <label class="custom-modal-body-detail"> Partner Deal / ดีลจากพันธมิตร </label>
                    <span v-if="data && data.partner_deal" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
            </template>
            <!-- section member type -->
            <template v-if="step == 'member_type'">
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('exclusive')">
                    <label class="custom-modal-body-detail"> Exclusive / เอ็กซ์คลูซีฟ </label>
                    <span v-if="data && data.exclusive" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('privilege')">
                    <label class="custom-modal-body-detail"> Privilege / พริวิเลจ </label>
                    <span v-if="data && data.privilege" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
            </template>
            <!-- section tag -->
            <template v-if="step == 'tag'">
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('new')">
                    <label class="custom-modal-body-detail"> New / ใหม่ </label>
                    <span v-if="data && data.new" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('hot_deal')">
                    <label class="custom-modal-body-detail"> Hot Deal / ดีลยอดนิยม </label>
                    <span v-if="data && data.hot_deal" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('free')">
                    <label class="custom-modal-body-detail"> Free / ฟรี </label>
                    <span v-if="data && data.free" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
            </template>
            <!-- section sort -->
            <template v-if="step == 'sort'">
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('a_z')">
                    <label class="custom-modal-body-detail"> A - Z </label>
                    <span v-if="data && data.a_z" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
                <div style="text-align: center; justify-content: space-between; display: flex" @click="onModalDataChange('z_a')">
                    <label class="custom-modal-body-detail"> Z - A </label>
                    <span v-if="data && data.z_a" class="fe fe-check" style="color: #141322; font-size: 18px; margin: auto 0; margin-right: 8px" />
                </div>
                <div style="width: 100%; border-bottom: 1px solid gray" />
            </template>
            <!-- footer -->
            <div class="custom-modal-footer">
                <a-button key="back" class="gray w-100" @click="save()">
                    {{ $t('Done') }}
                </a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['visible', 'step', 'data'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    methods: {
        cancel(reset_data = true) {
            this.$emit('on-cancel');
        },
        save() {
            if (this.step == 'sort') this.$emit('on-save');
            else if (this.step != 'filter') this.$emit('onModalStepChange', 'filter');
            else this.$emit('on-save');
        },
        onModalStepChange(step) {
            this.$emit('onModalStepChange', step);
        },
        onModalDataChange(key) {
            this.$emit('onModalDataChange', key);
            if (this.step == 'sort') {
                if (key == 'a_z' && this.data.z_a) this.$emit('onModalDataChange', 'z_a', false);
                if (key == 'z_a' && this.data.a_z) this.$emit('onModalDataChange', 'a_z', false);
            }
        },
        onModalClearAll() {
            this.$emit('onModalClearAll');
        },
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding: 8px 8px;
    padding-bottom: 0;
    text-align: center;
    justify-content: space-between;
    display: flex;
    border-bottom: 1px solid #707070;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-size: 16px;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-size: 14px;
    font-weight: 600;
    margin: 8px;
}
.custom-modal-footer {
    background: transparent;
    padding: 8px;
}
</style>